import { FC, useContext } from 'react';

// Utils
import { classNames, getLabelValue } from '@sportal365/smp-widget-utils';
import { ConfigContext } from '@velinsi/smp-widgets-ui';

interface Props {
  stageId: string;
  value: string;
  label: string;
  isSelected: boolean;
  setRound: (value: string) => void;
  setStage: (value: string) => void;
}

const DropdownOption: FC<Props> = ({ stageId, label, value, isSelected, setStage, setRound }) => {
  const { dataLabels } = useContext(ConfigContext);

  const handleRoundSelect = () => {
    setRound(value);
    setStage(stageId);
  };

  return (
    <div
      onClick={handleRoundSelect}
      className={classNames({
        'dropdown-option-container cursor-pointer p-4 max-h-[52px] border-solid border-b-selectOptionBorderColor border-[1px]': true,
        'bg-dropdownBtnColor text-hiContrast hover:bg-dropdownActiveBgColor hover:text-[#FF901A]': !isSelected,
        'bg-dropdownActiveBgColor text-[#FF901A]': isSelected,
      })}
    >
      <p className='dropdown-option-name m-0 text-4 font-bold'>
        {getLabelValue(dataLabels?.round, 'Round')} {label}
      </p>
    </div>
  );
};

export default DropdownOption;
